import { render, staticRenderFns } from "./AuthProviderButton.vue?vue&type=template&id=26996c00&scoped=true"
import script from "./AuthProviderButton.vue?vue&type=script&lang=ts"
export * from "./AuthProviderButton.vue?vue&type=script&lang=ts"
import style0 from "./AuthProviderButton.vue?vue&type=style&index=0&id=26996c00&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26996c00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default})
